export default defineNuxtPlugin((nuxtApp) => {
  const {
    public: { oneTrustId },
  } = useRuntimeConfig();

  if (!oneTrustId || oneTrustId === "") return;

  useScript({
    src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
    "data-document-language": true,
    "data-domain-script": String(oneTrustId),
  });

  nuxtApp.hook("i18n:localeSwitched", ({ newLocale }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const oneTrust = (window as any).OneTrust;
    if (!oneTrust) return;

    oneTrust.changeLanguage(newLocale);
  });
});
